import { KALOTECH_URL, openSitePage } from '../lib/siteUrl';

/**
 * "© <year> Kalotech LLC", with the studio name linking to kalotech.dev. Renders inline so
 * each caller keeps its own wrapper and type size.
 *
 * A real anchor with an absolute href, never a bare click handler: crawlers only follow
 * anchors, and the link is here for kalotech.dev's SEO. Deliberately no rel="nofollow".
 * The click goes through openSitePage, which on native escapes the WebView to the system
 * browser (same handling as Settings' legal rows; see src/lib/siteUrl.js).
 */
export default function KalotechCredit() {
  return (
    <>
      © {new Date().getFullYear()}{' '}
      <a
        href={KALOTECH_URL}
        className="kalotech-credit-link"
        onClick={e => { if (openSitePage(KALOTECH_URL)) e.preventDefault(); }}
      >
        Kalotech LLC
      </a>
    </>
  );
}
